import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RecommendationAlertsService {

  constructor(@Inject('bringozToastService') private bringozToastService: any) {
  }

  invokeActionSuccess() {
    if (this.bringozToastService) {
      this.bringozToastService.success({ body: 'RECOMMENDATION_INVOKE_ACTION_SUCCESS' });
    }
  }

  invokeActionError() {
    if (this.bringozToastService) {
      this.bringozToastService.error({
        body: 'RECOMMENDATION_INVOKE_ACTION_ERROR',
        details: 'SOMETHING_WENT_WRONG'
      });
    }
  }

  generateRecommendationsError(error?) {
    this.bringozToastService.error({
      body: 'RECOMMENDATION_GENERATE_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    });
  }

}
